export const loadPage = (url: string) => fetch(url).then(response => {
  if (!response.ok) {
    return Promise.reject(response)
  }

  return response.text()
})

/**
 * Runs `onIntersect` the first time `element` scrolls into view, then stops observing.
 * Used for below-the-fold content we do not want to fetch until a visitor is
 * actually heading towards it.
 */
export const observeOnce = (
  element: Element,
  onIntersect: () => void,
  options?: IntersectionObserverInit
): IntersectionObserver => {
  const observer = new IntersectionObserver(entries => {
    if (!entries[0].isIntersecting) return

    observer.disconnect()
    onIntersect()
  }, options)

  observer.observe(element)

  return observer
}
